import { render } from "./AddCompositionPage.vue?vue&type=template&id=06d50d55&ts=true"
import script from "./AddCompositionPage.vue?vue&type=script&lang=ts"
export * from "./AddCompositionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__